/**
 * Generador unificado de guías (reemplaza `/residue/guides/register`).
 * @see README.md
 */
export const RESIDUE_WAREHOUSE_GUIDE_REGISTER_PATH =
	'/warehouse/guide/register?category=residuos';

/** Ruta legacy deshabilitada (solo redirección). */
export const RESIDUE_LEGACY_GUIDE_REGISTER_PATH = '/residue/guides/register';

/** Edición de guías legacy (`/residue/guides/:id`) — deshabilitada por ahora. */
export const RESIDUE_GUIDE_EDIT_ENABLED = false;
